<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {}
</script>

<style lang="scss" scoped>
  .app{width: 100%;height: 100%;}
</style>



// WEBPACK FOOTER //
// src/App.vue